export default {"src":"/_next/static/media/academicLogo4.3d42e5e0.svg","height":48,"width":184,"blurWidth":0,"blurHeight":0};